import { computed, signal } from '@angular/core';
import { dsEnums, webDtos } from '@vectronic/openApi-admin';
import moment from 'moment';
import { BehaviorSubject, filter, startWith } from 'rxjs';

export class MockAbstractScheduleService {
  rulesIndexes$ = new BehaviorSubject<number[]>([0]);
  isRemovedSchedule$ = new BehaviorSubject(false);
  lastIndex = 0;
  rules$ = new BehaviorSubject<{ [key: number]: webDtos.ScheduleRule }>({});
  defaultRules$ = new BehaviorSubject<{ [key: number]: webDtos.ScheduleRule }>({});
  defaultRulesIndexes$ = new BehaviorSubject<number[]>([0]);
  scheduleType: dsEnums.ScheduleType;
  readonly isFilledAndChanged = signal(false);
  isEmptyScheduleSignal = computed(() => Object.values(this.rules$.value).length === 0);
  isRuleExpanded: { [key: number]: boolean } = {};
  errors = signal<string[]>([]);
  isValid = computed(() => !this.errors()?.length);
  isRemote = signal(true);
  isScheduleExpanded = signal(false);
  hasDefaultValue = signal(false);
  fixPerTransmission$ = new BehaviorSubject<number>(1);
  config = {
    hasSkipCount: true,
    maxSkipCount: 95,
    hasFixRate: true,
    hasCommunicationInterval: false,
    hasEmptySchedule: false,
  };
  rulesUpdatedAndFilled$ = this.rules$.pipe(
    filter((rules) => {
      if (this.isEmptySchedule) return true;
      return Object.values(rules).some((rule) => this.isRuleFilled(rule));
    }),
    startWith(undefined),
  );

  checkValidity() {}

  get hasRuleFromNowToThreeYears() {
    return true;
  }

  private isRuleFilled({ startTime, endTime, sequences, periodLength }: webDtos.ScheduleRule) {
    return Boolean(startTime && endTime && sequences?.length && periodLength);
  }

  private updateIsFilled() {}

  toggleRule() {}

  onClickAddRule() {}

  onRemoveRule() {}
  onRemoveSchedule() {}

  removeDefaultSchedule() {}

  setEmptySchedule() {}

  get isEmptySchedule() {
    return !Object.values(this.rules$.value).length;
  }

  updateRule() {}

  isEndDateAfterStartDate(startDate: string, endDate: string) {
    return moment(endDate).isSameOrAfter(moment(startDate));
  }
}
